import { useQuery } from "@tanstack/react-query";
import { getUserById } from "../../api/apiUsers";

/**
 * Hook لجلب مستخدم واحد
 * @param {number|string} id - User ID
 */
export function useGetUser(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["user", id],
        queryFn: () => getUserById(id),
        enabled: !!id,
        retry: false,
    });

    const user = data?.data || null;

    return { isLoading, error, user, refetch };
}